/*
 * File: createProduct.ts
 * Project: admin
 * File Created: Wednesday, 17th March 2021 4:11:22 pm
 * Author: Luis Aparicio (luis@inventures.cl)
 * -----
 * Last Modified: Tuesday, 27th April 2021 3:48:12 pm
 * Modified By: Luis Aparicio (luis@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */

import { gql } from '@apollo/client';
import { RawProduct } from 'src/interfaces';
import { ResolverParams } from '../../queries.interfaces';

export const createProduct = () => gql`
  mutation($params: CreateProductParams!) {
    createProduct(params: $params) {
      id
      uuid
      name
      description
      concentration
      prescriptionType
      unit
      quantity
      package
      routeOfAdministration
      composition
      posology
      display
      contraindications
      indications
      effectivenessPeriod
      prolongedRelease
      metadata {
        ispRegister
        cruzverdeSku
        pharolId
        salcobrandSku
        ligaSku
        manualfId
        vademecumId
        fasaSku
      }
      format
      isBioequivalent
      activePrinciple
      laboratory
      displayStatus
    }
  }
`;

export type CreateProductMutationParams = ResolverParams<
  Omit<
    RawProduct,
    'category' | 'uuid' | 'id' | 'price' | 'deletedAt' | 'availability'
  >
>;

export type CreateProductMutationResponse = {
  createProduct: RawProduct;
};
